import { Box } from "@chakra-ui/react";
import ResponsiveContainer from "@modules/Layout/components/ResponsiveContainer";
import { CompanyHistoryHero } from "@modules/Layout/style";
import React, { memo } from "react";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { ContentData } from "@types/common";

interface Props {
  content: ContentData;
}

const Content: React.FC<Props> = ({ content }) => {
  return (
    <ResponsiveContainer>
      <Box
        mt={16}
        mb={7}
        mx={"auto"}
        maxW={{ base: "100%", md: "80%", lg: "60%" }}
      >
        <CompanyHistoryHero>
          <ReactMarkdown children={content.data.content} />
        </CompanyHistoryHero>
      </Box>
    </ResponsiveContainer>
  );
};

export default memo(Content);
